var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-btn',{staticClass:"disable-events",attrs:{"color":"grey lighten-1"}},[_vm._v("\n    Waiting for Opponent\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }